import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton, ModalSecondaryButton } from "compid/custom-ui/CustomModal";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function DeleteAutoPayModal
 * @param {FUNCTION} onClick - Allows us to set an event handler on click to the primary modal button. 
 * @exported true
 * @returns {React.Component}
 * @description The modal that shows when a user wants to delete an autopay
 * @example
 * <DeleteAutoPayModal />
 */

export default function DeleteAutoPayModal(props) {
  const { close } = useBCMSModal();
  const onKeepPlanClick = evt => {
    close("DeleteAutoPayModal");
  };
  const onDeletePlanClick = evt => {
    props.data.onDeletePlanClick(evt);
    close("DeleteAutoPayModal");
  };
  return (
    <CustomModal id="DeleteAutoPayModal" className="delete-autopay-modal large-icon-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <div className="set-width">
          <SVGAsset id="AlertTriangleIcon" className="alert-icon left-icon" />
        </div>
        <div className="flex-width">
          <h4 className="modal-title"><b>Delete autopay plan?</b></h4>
          <p className="sub-text">Are you sure you want to delete this autopay plan? Any scheduled payments will be canceled.
            Processing payments will not be canceled.</p>
        </div>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal align-center">
        <ModalSecondaryButton text="Delete plan" onClick={ onDeletePlanClick } />
        <ModalPrimaryButton text="Keep plan" onClick={ onKeepPlanClick } />
      </CustomModalFooter>
    </CustomModal>
  )
}
